import restArguments from './restArguments.js';
import unzip from './unzip.js';

// Zip together multiple lists into a single array -- elements that share
// an index go together.
export default restArguments(unzip);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/zip.js
// module id = 890
// module chunks = 115